module.exports = __webpack_public_path__ + "assets/img/HKHC.9c1e6abc.png";